import { deleteRequest, patchRequest, postRequest } from 'src/state/utils'

export const setStandardAssembly: RequestTypeVariable = {
  getKey: (projectId: string) => ['setStandardAssembly', projectId],
  request: async (projectId: string, assemblyGuid: string): Promise<Assembly[]> => {
    const { data } = await patchRequest<Assembly[]>({
      url: `/projects/${projectId}/standard-assembly`,
      data: { assemblyGuid },
    })

    return data as Assembly[]
  },
}

export const deleteAssembly = {
  key: 'deleteAssembly',
  request: async (id: string): Promise<Assembly[]> => {
    const { data } = await deleteRequest<Assembly[]>({
      url: `/assemblies/${id}`,
    })

    return data as Assembly[]
  },
}

export const deleteProjectAssembly = {
  getKey: (projectId: string) => ['deleteProjectAssembly', projectId],
  request: async (projectId: string, id: string): Promise<Assembly[]> => {
    const { data } = await deleteRequest<Assembly[]>({
      url: `/projects/${projectId}/assemblies/${id}`,
    })

    return data as Assembly[]
  },
}

export const createAssembly = {
  key: 'createAssembly',
  request: async (data: Assembly): Promise<CLTAssembly | TimberFrameAssembly> => {
    const { data: result } = await postRequest<CLTAssembly | TimberFrameAssembly>({
      url: `/assemblies`,
      data,
    })

    return result as CLTAssembly | TimberFrameAssembly
  },
}

export const createProjectAssembly = {
  getKey: (projectId: string) => ['createProjectAssembly', projectId],
  request: async (id: string, data: Assembly): Promise<CLTAssembly | TimberFrameAssembly> => {
    const { data: result } = await postRequest<CLTAssembly | TimberFrameAssembly>({
      url: `/projects/${id}/assemblies`,
      data,
    })

    return result as CLTAssembly | TimberFrameAssembly
  },
}

export const editAssembly = {
  key: 'editAssembly',
  request: async (data: Assembly): Promise<CLTAssembly | TimberFrameAssembly> => {
    const { data: result } = await postRequest<CLTAssembly | TimberFrameAssembly>({
      url: `/assemblies/${data.guid}`,
      data,
    })

    return result as CLTAssembly | TimberFrameAssembly
  },
}

export const editProjectAssembly = {
  getKey: (projectId: string) => ['editProjectAssembly', projectId],
  request: async (
    projectId: string,
    data: Assembly,
  ): Promise<CLTAssembly | TimberFrameAssembly> => {
    const { data: result } = await postRequest<CLTAssembly | TimberFrameAssembly>({
      url: `/projects/${projectId}/assemblies/${data.guid}`,
      data,
    })

    return result as CLTAssembly | TimberFrameAssembly
  },
}

/** Write assembly onto selected walls / vertical slabs (propagates to AssemblyStandard dependents). */
export const updateElementAssemblies: RequestTypeVariable = {
  getKey: (projectId: string) => ['updateElementAssemblies', projectId],
  request: async (
    projectId: string,
    data: { element_guids: string[]; assembly_guid: string },
  ): Promise<void> => {
    await patchRequest({
      url: `/projects/${projectId}/planar-model/element-assemblies`,
      data,
    })
  },
}

/** @deprecated Use updateElementAssemblies — kept name alias for gradual call-site migration. */
export const editAssemblyAssignment = {
  getKey: (projectId: string) => ['editAssemblyAssignment', projectId],
  request: async (
    projectId: string,
    data: { element_guids: string[]; assembly_guid: string },
  ): Promise<void> => {
    return updateElementAssemblies.request(projectId, data)
  },
}
